const HeaderMobileScreen = ({ title, download, toggle, handleImageLink }) => {
  const downloadIcon = (
    <img
      src="/icons/download_white.svg"
      alt="Download"
      className={
        download === "eng"
          ? "header-mobilescreen-english-download-arrow"
          : "header-mobilescreen-arabic-download-arrow"
      }
    />
  );

  const titleStyle = toggle
    ? {
        fontFamily: "Decima Mono Pro",
        ...(handleImageLink ? { textDecoration: "underline" } : {}),
      }
    : {};

  return (
    <div className="header-mobilescreen">
      <div
        className="header-mobilescreen-name"
        style={titleStyle}
        onClick={() => handleImageLink && handleImageLink(false)}
      >
        {title}
      </div>

      {download === "eng" ? (
        <a
          href="pdf/educator_english.pdf"
          download
          className="header-mobilescreen-english-download"
        >
          download pdf {downloadIcon}
        </a>
      ) : download === "arab" ? (
        <a
          href="pdf/educator_arabic.pdf"
          download
          className="header-mobilescreen-arabic-download"
        >
          {downloadIcon}
          <span className="educator-mobilescreen-arabic-download-pdf-text">
            PDF تحميل
          </span>
        </a>
      ) : null}
    </div>
  );
};

export default HeaderMobileScreen;
